import React from 'react'
import {ExtendMetaData, ExtendMetaDataInputInfo, ExtendMetaDataItem} from '../../../../DTO/ExtendMetaDataDTO'
import {PIMCard} from '../../../Atoms/Cards/PIMCard'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {MBContentBodyTypography, MBContentSubTitleTypography} from '../../../Atoms/Typographies'

type ExtendMetaDataConfirmBlockProps = {
  extendMetaData: ExtendMetaData[]
  extendMetaDataInputInfo: ExtendMetaDataInputInfo
}
export const ExtendMetaDataConfirmBlock: React.VFC<ExtendMetaDataConfirmBlockProps> = (
  {extendMetaData, extendMetaDataInputInfo},
) => {
  return (<>
    {extendMetaData.map((block, idx) =>
      <PIMCard
        headerProps={{title: block.header}}
        key={idx}
        testId={`block-confirm-extend-meta-data-${idx}`}
      >
        <PIMStack
          spacing={'18px'}
          divider={<MBContentBodyDivider/>}
          showEndDivider
        >
          {block.items.map(item =>
            <PIMStack spacing={'10px'} key={`confirm-area-${item.id}`}>
              {block.items.length > 1 &&
                <MBContentSubTitleTypography>{item.label}</MBContentSubTitleTypography>}
              <MBContentBodyTypography>
                {getLabel(item, extendMetaDataInputInfo[item.id])}
              </MBContentBodyTypography>
            </PIMStack>,
          )}
        </PIMStack>
      </PIMCard>,
    )}
  </>)
}

const getLabel = (
  extendMetaDataItem: ExtendMetaDataItem,
  inputValue: number | undefined,
): string => {
  const findOption =
    extendMetaDataItem.options.find(option => option.id === inputValue)
  return findOption ? findOption.label : ''
}
